/**
 * Enquanto `ativo`, recarregar ou fechar a aba pede confirmacao do navegador.
 *
 * Serve a telas com alteracao nao salva (Editor de formulario, FORM-31). A
 * navegacao DENTRO do app nao passa por aqui: o app usa BrowserRouter, sem o
 * `useBlocker` do data router, entao a tela confirma nos proprios botoes de
 * navegacao (abas, voltar).
 */
import { useEffect } from "react";

export default function useAvisoAoSairDaPagina(ativo) {
  useEffect(() => {
    if (!ativo) return undefined;
    const avisar = (evento) => {
      evento.preventDefault();
      // Chrome e Edge so mostram o aviso com `returnValue` preenchido.
      evento.returnValue = "";
    };
    window.addEventListener("beforeunload", avisar);
    return () => window.removeEventListener("beforeunload", avisar);
  }, [ativo]);
}
